const Unauthorized = () => (
  <div className="h-screen flex items-center justify-center">
    <h1 className="text-2xl font-bold text-red-600">
      Access Denied 🚫
    </h1>
  </div>
);

export default Unauthorized;
